<style scoped>
.total-row {
  font-weight: bolder;
  font-size: 1.04rem;
}
</style>
<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-expansion-panels variant="accordion" v-model="filterPanel">
            <v-expansion-panel value="searchFiltersPanel" rounded="rounded-xl">
              <v-expansion-panel-title
                style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important" v-ripple>
                <v-row style="opacity: 1 !important">
                  <v-col cols="12" sm="3">
                    <span class="v-card-title">Filtro de pesquisa</span>
                  </v-col>
                </v-row>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="bg-grey-lighten-2">
                <v-row density="compact">
                  <v-col cols="12" sm="6" align-self="start">
                    <v-row align="start" density="compact">
                      <v-col cols="12" md="2">
                        <v-label>Período</v-label>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="De" density="compact" v-model="filters.payment_date_from">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="Até" density="compact" v-model="filters.payment_date_to">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="9" sm="6">
                    <AutocompleteSelectGroup @selected="selectedGroup" v-if="hasAdminAccess" />
                  </v-col>
                  <v-col cols="12" md="3" sm="4">
                    <v-select :items="[50, 100, 200, 500]" v-model="filters.itemsPerPage" label="Resultados por página"
                      density="compact" hide-details></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-btn color="warning" @click="clearFilters()">
                    <v-icon class="mr-2">mdi-broom</v-icon>
                    <span v-if="mdAndUp">Limpar Pesquisa</span>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" @click="exportInvoices()">
                    <v-icon>mdi-file-excel-box</v-icon>
                    <span v-if="mdAndUp">Excel</span>
                  </v-btn>
                  <v-btn color="secondary" @click="downloadSearch">
                    <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
                    <span v-if="mdAndUp">Download</span>
                  </v-btn>
                  <v-btn color="primary" type="submit">
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    <span v-if="mdAndUp">Pesquisar</span>
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row align="center" justify="space-between" style="min-height:72px;">
              <v-col cols="auto" v-if="showSelectHeaders">
                <v-select label="Campos da tabela" item-title="title" return-object :items="headers" hide-details
                  multiple clearable chips v-model="selectedHeaders" density="compact"
                  @update:modelValue="saveSelectedHeaders"></v-select>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn icon density="compact" v-bind="props" variant="text">
                      <v-icon color="grey-lighten-1" @click="showSelectHeaders = !showSelectHeaders">
                        mdi-cog
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Configurar Cabeçalhos</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table-server class="elevation-1" density="compact" :items-per-page="filters.itemsPerPage"
            :headers="selectedHeaders" :items="lstObjects" :items-length="serverTable.total + 1"
            :loading="requestingApi" :search="searchFilter" fixed-header hide-default-footer :sortable="false"
            @update:options="loadItems">
            <template v-slot:bottom>
              <v-row>
                <v-col>
                  <div class="text-center pt-2">
                    <span>Mostrando os itens {{ serverTable.from }} até {{ serverTable.to }} de {{
                      serverTable.total }}</span>
                    <v-pagination density="compact" v-model="serverTable.page" :length="serverTable.maxPage"
                      show-first-last-page></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </template>
            <!-- Customize Total Row Rendering -->
            <template v-slot:item="{ item, index }">
              <tr :class="{ 'total-row': item.isTotal }">
                <td v-for="(header, colIndex) in headers" :key="colIndex" class="text-center">
                  <span v-if="header.key === 'payment_date' && item.payment_date">
                    {{ $moment.parseZone(item.payment_date).format('DD/MM/YYYY') }}
                  </span>
                  <span v-else-if="header.key === 'category'">
                    {{ calcCategory(item) }}
                  </span>
                  <span v-else-if="header.key === 'person' && (item.from || item.to)">
                    {{ calcPerson(item) }}
                  </span>
                  <span v-else-if="header.key === 'total_amount'">
                    {{ $filters.currency(item.paid_amount, 'BRL') }}
                  </span>
                  <span v-else-if="header.key === 'amount'">
                    {{ calcNetAmount(item) }}
                  </span>
                  <span v-else-if="header.key === 'net_onlending'">
                    {{ calcNetOnlending(item) }}
                  </span>
                  <span v-else-if="header.key === 'onlending_date' && item?.receipt?.created_at">
                    {{ getOnlendingDate(item)?.format("DD/MM/YYYY") || '' }}
                  </span>
                  <span v-else-if="header.key === 'onlending_value'">
                    {{ calcOnlending(item) }}
                  </span>
                  <!-- Add other column-specific formats here -->
                  <span v-else>{{ item[header.key] }}</span>
                  <!-- Show Totals in Specific Columns -->
                  <span v-if="item.isTotal && totals[header.value]">
                    {{ totals[header.value] }}
                  </span>
                  <span v-else>{{ item[header.value] }}</span>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { useDisplay } from 'vuetify';
import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import api from '@/services'

export default {
  setup() {
    // Destructure only the keys we want to use
    const { mdAndUp } = useDisplay();

    return { mdAndUp }
  },
  components: {
    AutocompleteSelectGroup,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      initialized: false,
      tab: 1,
      onlendingData: [],
      headers: [
        { title: "ID", align: "start", key: "id", sortable: false },
        { title: "Data", align: "end", key: "payment_date", sortable: false },
        { title: "Natureza", align: "start", key: "category", sortable: false },
        { title: "Nome", align: "start", key: "person", sortable: false },
        { title: "Valor Bruto", align: "end", key: "total_amount", sortable: false },
        { title: "Valor dos Serviços", align: "end", key: "amount", sortable: false },
        { title: "Valor Líquido Repassado", align: "end", key: "net_onlending", sortable: false },
        { title: "Data do Repasse", align: "end", key: "onlending_date", sortable: false },
        { title: "Valor do Repasse", align: "end", key: "onlending_value", sortable: false },
      ],
      selectedHeaders: [],
      showSelectHeaders: false,
      lstObjects: [],
      filterPanel: "searchFiltersPanel",
      filters: {
        withUser: true,
        special_filters: [],
        statuses: [],
        itemsPerPage: 1,
        orderBy: null,
        is_human: null,
        invoice_type: null,
        group_id: null,
        legal_people_ids: [],
        subgroup_ids: [],
        cashflow_category_ids: [],
        payment_method_ids: [],
        payment_date_from: null,
        payment_date_to: null,
        due_date_from: null,
        due_date_to: null
      },
      searchFilter: null,
      serverTable: {
        total: 0,
        from: 0,
        to: 0,
        page: 1,
        maxPage: 1,
      },
    };
  },
  created() {
    var vm = this;

    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    calcPerson(invoice) {
      const vm = this;

      switch (invoice.type) {
        case vm.$INVOICE_TYPE_DIC.INVOICE.value:
          return invoice?.to?.name;
        case vm.$INVOICE_TYPE_DIC.BILL.value:
          return !api.storage.isGroupSelected() || api.storage?.selectedGroup()?.id === 777 ? invoice?.to?.name : invoice?.from?.name;
        case vm.$INVOICE_TYPE_DIC.SERVICE.value:
          return !api.storage.isGroupSelected() || api.storage?.selectedGroup()?.id === 777 ? invoice?.to?.name : invoice?.from?.name;
        default:
          return 'TIPO NÃO DEFINIDO ' + invoice.type;
      }
    },
    calcCategory(invoice) {
      return invoice?.categories?.length > 0 ? invoice.categories.sort((c1, c2) => c2.parent_category_id - c1.parent_category_id)[0].name : '';
    },
    calcNetAmount(invoice) {
      const vm = this;
      const proportional = (invoice.paid_amount / invoice.receipt.paid_amount) ?? 1;
      const propTax = (invoice.receipt.paid_amount - invoice.receipt.after_taxes_amount) * proportional ?? 1;

      return vm.$filters.currency(propTax, 'BRL');
    },
    calcNetOnlending(invoice) {
      const vm = this;
      const proportional = (invoice.paid_amount / invoice.receipt.paid_amount) ?? 1;
      const propTax = (invoice.receipt.paid_amount - invoice.receipt.after_taxes_amount) * proportional ?? 1;

      return vm.$filters.currency(invoice.paid_amount - propTax, 'BRL');
    },
    calcOnlending(invoice) {
      if (invoice.isTotal || invoice?.checkout?.id == null) {
        return;
      }
      const vm = this;
      const onlendingInvoice = (vm.onlendingData || []).find(oi => +oi.ref === invoice.checkout.id);
      if (onlendingInvoice == null) {
        return;
      }

      return onlendingInvoice.receipt == null ? 'FUTURO' : vm.$filters.currency(onlendingInvoice?.receipt?.paid_amount, 'BRL');
    },
    getOnlendingDate(invoice) {
      // Paid invoices may have no checkout (write-off / legacy); relation is also PAID-only on BE.
      if (invoice.isTotal || invoice?.checkout?.id == null) {
        return;
      }
      const vm = this;
      const onlendingInvoice = (vm.onlendingData || []).find(oi => +oi.ref === invoice.checkout.id);
      if (onlendingInvoice == null) {
        return;
      }
      if (onlendingInvoice.receipt == null && onlendingInvoice.status === 11) {
        return vm.$moment.parseZone(onlendingInvoice.due_date ?? 0);
      }

      return vm.$moment.parseZone(onlendingInvoice?.receipt?.created_at ?? 0);
    },
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_analytical_financial_movement_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    selectedGroup(group) {
      var vm = this;
      vm.filters.group_id = group?.id;
    },
    loadParameters() {
      var vm = this;
      const configuration = api.storage.selectedGroup().configuration || {};
      let _itemsPerPage = localStorage["_analytical_finance_movements_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 200);

      try {
        let _headers = localStorage["_analytical_financial_movement_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }

      vm.filters.statuses = [vm.$INVOICE_STATUS_DIC.PAID.value];
      vm.filters.payment_method_ids = [1, 2, 3];//Trocar por consulta
      vm.filters.cashflow_category_ids = [];
      vm.filters.invoice_type = 'Recebimento';
      vm.filters.orderBy = [{ key: "payment_date", order: "asc" }, { key: "legal_person_to", order: "asc" }];
    },
    clearFilters() {
      var vm = this;

      vm.searchFilter = null;
      vm.filters.orderBy = null;
      vm.filters.group_id = null;
      vm.filters.is_human = null;
      vm.filters.searchText = null;
      vm.filters.payment_date_to = null;
      vm.filters.payment_date_from = null;
      vm.filters.type = [];
      vm.filters.subgroup_ids = [];
      vm.filters.special_filters = [];
    },
    submitSearch(page) {
      var vm = this;

      if (vm.hasFinancialAccess) {
        if (!vm.requestingApi) {
          vm.requestingApi = true;
          vm.initialized = true;
          vm.serverTable.page = page || 1;
          return new Promise((resolve, reject) => {
            api.invoice.listAdmin(vm.filters, vm.serverTable.page)
              .then((result) => {
                const rows = result?.data || [];
                vm.serverTable.total = result?.total;
                vm.serverTable.from = result?.from;
                vm.serverTable.to = result?.to;
                vm.serverTable.maxPage = result?.last_page;

                // Collect checkout IDs (relation is PAID-only; write-offs / unlinked may be null)
                const checkoutIds = [
                  ...new Set(rows
                    .map(item => item?.checkout?.id)
                    .filter(id => id != null)
                    .sort())
                ];

                const sortByOnlending = (data) => data.slice().sort((a, b) => {
                  const onlendingDateA = vm.getOnlendingDate(a);
                  const onlendingDateB = vm.getOnlendingDate(b);

                  if (onlendingDateA && onlendingDateB) {
                    if (onlendingDateA.isSame(onlendingDateB, 'day')) {
                      return (a?.to?.name || '').localeCompare(b?.to?.name || '');
                    }
                    return onlendingDateA.valueOf() - onlendingDateB.valueOf();
                  } else if (onlendingDateA) {
                    return -1;
                  } else if (onlendingDateB) {
                    return 1;
                  }
                  return 0;
                });

                if (checkoutIds.length > 0) {
                  return api.invoice.analytical({ checkout_ids: checkoutIds })
                    .then((onlendingResult) => {
                      vm.onlendingData = Array.isArray(onlendingResult) ? onlendingResult : [];
                      vm.lstObjects = sortByOnlending(rows);
                    });
                }

                vm.onlendingData = [];
                vm.lstObjects = sortByOnlending(rows);
              })
              .then(() => {
                if (!Array.isArray(vm.lstObjects)) {
                  vm.lstObjects = [];
                }
                vm.lstObjects.push(vm.totals);
                vm.$notify({
                  type: "success",
                  text: "Pesquisa concluída",
                });
                vm.filterPanel = "";
                resolve();
              })
              .catch((err) => {
                if (err.message) {
                  vm.$notify({
                    type: "warn",
                    text: err.message,
                  });
                }
                reject(err);
              })
              .finally(() => {
                vm.requestingApi = false;
              });
          });
        }
      } else {
        vm.$notify({
          type: "warn",
          text: "Nível de acesso insuficiente",
        });
      }
    },
    downloadSearch() {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.pdf.downloadAnalytical(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `Analítico_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.pdf`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              resolve(result);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "error",
                  text: err.message,
                });
              } else {
                reject(err);
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    exportInvoices() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.excel.exportAnalytical(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `Analítico_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.xlsx`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              resolve(result);
            }).catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    loadItems({ page, itemsPerPage, sortBy }) {
      const vm = this;

      if (vm.initialized) {
        if (sortBy?.length > 0) {
          vm.filters.orderBy = sortBy;
        } else {
          vm.filters.orderBy = null;
        }
        vm.submitSearch(page);
      }
    },
  },
  computed: {
    hasFinancialAccess() {
      const vm = this;

      return vm.hasGroupAdminAccess || vm.hasAdminAccess || vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.FINANCIAL_ADMIN.value;
    },
    hasGroupAdminAccess() {
      const vm = this;

      return vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    hasAdminAccess() {
      const vm = this;

      return vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
    },
    totals() {
      const vm = this;
      const totals_receipt = {
        paid_amount: this.lstObjects.reduce((sum, item) => sum + +item?.receipt?.paid_amount || 0, 0),
        after_taxes_amount: this.lstObjects.reduce((sum, item) => sum + +item?.receipt?.after_taxes_amount || 0, 0),
      }

      // Calculate totals for specific columns
      return {
        id: 'Total',
        paid_amount: vm.lstObjects.reduce((sum, item) => sum + +item?.paid_amount || 0, 0),
        receipt: totals_receipt,
        isTotal: true,
      };
    },
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_invoices_itemsPerPage"] = newVal;
    },
    "serverTable.page"(newVal) {
      var vm = this;

      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    }
  },
};
</script>